import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
    MenuItem,
    Box
} from '@material-ui/core';

import SelectTextField from '../SelectTextField';
import FilterLabel from './FilterLabel';
import { filterPropTypes } from '../../../../utility/prop_types/CriteriaPropType';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';

function MultiSelectFilter ({ tree, field, onChange, onClear }) {
    const classes = useStyles();

    function handleChange (event) {
        if (event.target.value.length === 0) {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            newTree.properties = {
                ...newTree.properties,
                operator: '==',
                [event.target.name]: event.target.value
            };
            onChange(newTree);
        }
    }

    function renderSelected (selected) {
        if (selected.length === 0) {
            return <div className={classes.any}>Any</div>;
        } else {
            const selectedOptions = field.settings.listOptions
                .filter(el => selected.includes(el.value))
                .map(el => el.label || el.value);

            return selectedOptions?.length === 1 ? 
                selectedOptions[0]?.label ? selectedOptions[0].label : 
                    selectedOptions?.[0]?.value ? selectedOptions[0].value : selectedOptions[0]
                : `${selectedOptions.length} items selected`;
        }
    }

    const values = tree.properties.values || [];

    return (
        <div className={classes.root}>
            <FilterLabel field={field} />
            <SelectTextField
                name="values"
                value={values}
                onChange={handleChange}
                SelectProps={{
                    displayEmpty: true,
                    multiple: true,
                    renderValue: renderSelected
                }}
            >
                { field.settings.listOptions.map(el => <MenuItem key={el.value} value={el.value} 
                classes={{
                  root: classes.menuItem
                }}
                >
                    {el.label || el.value}
                    {
                        values?.filter(e=>e === el.value)?.length > 0 ? <CheckBox color="secondary" />:<CheckBoxOutlineBlank />
                    }
                    </MenuItem>) }
            </SelectTextField>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        '&> *:not(:last-child)': {
            marginRight: 10,
        },
        '&> div': {
            flexGrow: 1
        }
    },
    any: {
        color: '#a9a9a9'
    },
    clear: {
        height: 36
    },
    menuItem:{
        display: "flex",
        justifyContent: "space-between",
        gap: 8,
    },
}));

MultiSelectFilter.propTypes = filterPropTypes;

export default MultiSelectFilter;